<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white">Dashboard</router-link>
            <router-link to="/school/hostel-management" class="text-white">
                <i class="fa fa-ellipsis-v mx-2"></i>Hostel Management
            </router-link>
            <span class="text-white"><i class="fa fa-ellipsis-v mx-2"></i>Hostel</span>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <div class="mb-5 mb-xl-0">
                <card header-classes="bg-transparent">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="card bg-secondary">
                                <h3 class=" card-header">Registration</h3>
                                <div class="card-body">
                                    <div class="form-horizontal">
                                        <form role="form" @submit.prevent="submitdata">
                                            <div class="form-group">
                                                <label>Hostel Name</label>
                                                <input v-model="HostelNameval" placeholder="Enter Hostel Name" class="form-control" required />
                                            </div>
                                            <div class="text-center card-footer">
                                                <button type="submit" class="btn btn-primary">
                                                    Submit
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-8">
                            <div class="justify-content-end form-inline mt-3">
                                <base-input class="input-group-alternative" placeholder="Search here..."
                                    addon-left-icon="fa fa-search" v-model="searchval">
                                </base-input>
                            </div>
                            <div class="table-responsive mt-2">
                                <table class="table table-bordered table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>Hostel Name</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in searchedResultQuery" :key="item.Id">
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ item.HostelName }}</td>
                                            <td>
                                                <button class="btn btn-secondary btn-sm" v-on:click="edititem(item.Id)">
                                                    <i class="fa fa-edit"></i> Edit
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
            <!-- End charts-->
        </div>
    </div>
</template>

<script>
import Alert from "@/mixins/Alert.mixins"
import HostelMixin from "@/mixins/Hostel.mixin"
import PageSpinner from "@/components/PageSpinner"
export default {
    name: "Hostel",
    mixins: [HostelMixin, Alert],
    components: {
        PageSpinner
    },
    data() {
        return {
            accessDetails: null,
            Idval: 1,
            HostelNameval: '',
            HostelItems: null,
            process: 'N',
            searchval: '',
            onloader: 'none'
        };
    },
    computed: {
        searchedResultQuery() {
            if (this.searchval) {
                return this.HostelItems.filter(item => {
                    return this.searchval
                        .toLowerCase()
                        .split(" ")
                        .every(
                            v =>
                                item.HostelName.toLowerCase().includes(v)
                        );
                });
            } else {
                return this.HostelItems;
            }
        }
    },
    methods: {
        edititem(Id) {
            this.onloader = "flex";
            this.$store
                .dispatch("hostel/GetByIdHostel", Id)
                .then(resp => {
                    this.Idval = Id;
                    this.HostelNameval = resp.HostelName;
                    this.process = "U";
                    this.onloader = "none";
                })
                .catch(err => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        submitdata() {
            let Id = this.Idval;
            let HostelName = this.HostelNameval;
            let processop = this.process;
            let username = this.$store.state.auth.username;
            let accesskey = this.$store.state.auth.accesskey;
            let userdata = {
                Id,
                HostelName,
                processop,
                username,
                accesskey
            };
            this.onloader = "flex";
            this.$store
                .dispatch("hostel/ProcessHostel", userdata)
                .then(resp => {
                    this.HostelItems = resp;
                    this.HostelNameval = ''
                    this.process = 'N';
                    this.onloader = 'none';
                    this.ShowAlertSuccess('Submitted Successfully', '');
                })
                .catch(err => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },

    },
    mounted() {
        this.accessDetails = this.$store.getters['auth/_user'];
        if (this.accessDetails.isSchoolStaff == false) {
            this.$store.dispatch('auth/Logout')
            this.$router.push('/login')
        }
    }
};
</script>

<style></style>
